import { AnimatePresence, motion } from 'framer-motion';
import styles from './Table.module.css';

export const Table = ({
  rows,
  cols,
  messages,
  scaleMsg,
  msgFontSize,
  animRotateDuration,
  animMovementDelay,
  animMovementDuration,
  animGlareDuration,
}) => {
  if (!rows?.length || !cols?.length) {
    return;
  }

  const stringValue = messages
    .filter((m) => m.col?.start && m.row?.start)
    .map((m) => m.col?.start + ',' + m.row?.start);

  let res = [];
  let isColize = [];
  let texts = [];

  stringValue.forEach((el) => {
    if (!res.includes(el)) {
      res.push(el);
    } else {
      if (!isColize.includes(el)) {
        const messagesColize = messages.filter(
          (m) => m.col?.start + ',' + m.row?.start === el,
        );

        isColize.push(el);
        texts.push({
          colize: el,
          messages: [...messagesColize.map((m) => m.message.content)],
        });
      }
    }
  });

  const widthCol = 181 / cols.length; // padding App 4rem, width rowNameBlock 15rem - all 200rem=1920px
  const heightRow = 92.5 / rows.length; // title 10rem, cols 8rem,  padding App 2rem- all 112.5rem=1080px

  return (
    <div
      className={styles.wrapper}
      style={{
        gridTemplateColumns: `repeat(${cols.length}, minmax(10rem, 100rem))`,
        gridTemplateRows: `repeat(${rows.length}, minmax(10rem, 100rem))`,
      }}
    >
      <div>
        <ul className={styles.cols}>
          {cols.map((col) => (
            <li
              key={col}
              style={{ width: `${widthCol}rem` }}
              className={styles.colName}
            >
              {col}
            </li>
          ))}
        </ul>
        <div className={styles.rowsBlock}>
          <ul className={styles.rows}>
            {rows.map((row) => (
              <li
                key={row}
                style={{ height: `${heightRow}rem` }}
                className={styles.rowNameBlock}
              >
                <div className={styles.rowName}>{row}</div>
              </li>
            ))}
          </ul>
          <div className={styles.ceils}>
            {messages.map((msg, idx) => {
              const positionString = msg.col?.start + ',' + msg.row?.start;
              const isColizeMsg = isColize.includes(positionString);

              const isPosition = msg.col?.start && msg.row?.start;
              return (
                <AnimatePresence mode="wait" key={msg.message.id}>
                  {((msg.col?.start && msg.row?.start) ||
                    msg.visible?.status) && (
                    <motion.div
                      initial={{
                        position: 'absolute',
                        left: '46%',
                        top: '45%',
                        x: '-50%',
                        y: '-50%',
                        scale: scaleMsg,
                        zIndex: 1000 + idx,
                      }}
                      animate={{
                        transition: {
                          left: {
                            delay: animMovementDelay,
                            duration: animMovementDuration,
                          },
                          top: {
                            delay: animMovementDelay,
                            duration: animMovementDuration,
                          },
                          x: {
                            delay: animMovementDelay,
                            duration: animMovementDuration,
                          },
                          y: {
                            delay: animMovementDelay,
                            duration: animMovementDuration,
                          },
                          scale: {
                            delay: animMovementDelay,
                            duration: animMovementDuration,
                          },
                          zIndex: {
                            delay: animMovementDelay + animMovementDuration,
                            duration: animGlareDuration,
                          },
                        },
                        position: 'absolute',
                        left: isPosition
                          ? `${(msg.col?.start - 1) * widthCol}rem`
                          : '46%',
                        top: isPosition
                          ? `${(msg.row?.start - 1) * heightRow}rem`
                          : '45%',
                        x: isPosition ? 0 : '-50%',
                        y: isPosition ? 0 : '-50%',

                        scale: isPosition ? 1 : scaleMsg,
                        zIndex: !isPosition ? 1000 + idx : idx,
                      }}
                      exit={{ scale: 0 }}
                      className={styles.item}
                      style={{
                        gridColumnStart: msg.col?.start,
                        gridRowStart: msg.row?.start,
                        width: `${widthCol}rem`,
                        height: `${heightRow}rem`,
                      }}
                    >
                      <motion.div
                        className={styles.rotateBlock}
                        initial={{
                          transform: 'perspective(800px) rotateX(-90deg)',
                        }}
                        animate={{
                          transition: {
                            transform: {
                              duration: animRotateDuration,
                            },
                          },
                          transform: 'perspective(800px) rotateX(0deg)',
                        }}
                      >
                        <div
                          className={`${styles.card} ${
                            isColizeMsg ? styles.colize : ''
                          }`}
                          style={{
                            fontSize: `${msgFontSize}rem`,
                            overflow: isColizeMsg ? 'visible' : '',
                          }}
                        >
                          {!isColizeMsg && (
                            <motion.div
                              initial={{ left: '-100%' }}
                              animate={{ left: '100%' }}
                              transition={{
                                delay: animRotateDuration,
                                duration: animGlareDuration,
                              }}
                              className={styles.light}
                            />
                          )}

                          <AnimatePresence mode="wait">
                            {isColizeMsg ? (
                              <motion.div
                                key={isColizeMsg}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 0.5 }}
                                exit={{ opacity: 0 }}
                                className={styles.colizeText}
                              >
                                {texts
                                  .find((el) => el.colize === positionString)
                                  ?.messages?.map((text) => (
                                    <div
                                      key={text}
                                      style={{
                                        fontSize:
                                          text.length > 20
                                            ? `${msgFontSize * 0.8}rem`
                                            : `${msgFontSize}rem`,
                                        lineHeight:
                                          text.length > 20 ? 1.4 : 1.5,
                                      }}
                                    >
                                      {text}
                                    </div>
                                  ))}
                              </motion.div>
                            ) : (
                              <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 0.3 }}
                                exit={{ opacity: 0 }}
                              >
                                {msg.message.content.trim()}
                              </motion.div>
                            )}
                          </AnimatePresence>
                        </div>
                      </motion.div>
                    </motion.div>
                  )}
                </AnimatePresence>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
